module.exports = __webpack_public_path__ + "static/media/widharmika_agung.82a25bd9.jpg";